import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M11.875 7.597 10.623 8.94l.32 1.771a.366.366 0 0 1-.017.19.351.351 0 0 1-.111.153.321.321 0 0 1-.348.033l-1.626-.83-1.596.83a.321.321 0 0 1-.352-.032.366.366 0 0 1-.13-.343L7.09 8.94 5.815 7.597a.366.366 0 0 1-.094-.352.345.345 0 0 1 .1-.158.324.324 0 0 1 .163-.08l1.747-.296.815-1.655a.204.204 0 0 1 .036-.051.29.29 0 0 1 .094-.088l.071-.033a.296.296 0 0 1 .09 0h.004a.249.249 0 0 1 .084 0l.076.033c.038.02.07.05.094.088a.204.204 0 0 1 .035.05l.798 1.656 1.747.297a.34.34 0 0 1 .263.236.367.367 0 0 1-.063.353ZM8.68 4.907l.071-.032-.057.023-.014.01Z M13.333 8a4.5 4.5 0 1 0-4.5 4.5V14a6 6 0 1 1 0-12 6 6 0 0 1 0 12v-1.5a4.5 4.5 0 0 0 4.5-4.5Z';
const draw24px =
  'm18.674 11.226-2.404 2.581.616 3.4c.02.124.009.25-.035.366a.675.675 0 0 1-.213.293.618.618 0 0 1-.668.063l-3.123-1.594-3.063 1.594a.618.618 0 0 1-.676-.062.675.675 0 0 1-.213-.294.702.702 0 0 1-.035-.365l.625-3.4-2.447-2.582a.703.703 0 0 1-.18-.677.661.661 0 0 1 .19-.302.621.621 0 0 1 .315-.152l3.354-.57 1.566-3.178a.39.39 0 0 1 .068-.098.556.556 0 0 1 .18-.169l.136-.062a.569.569 0 0 1 .172 0h.008a.478.478 0 0 1 .163 0l.145.062c.073.04.135.098.18.17a.39.39 0 0 1 .068.097l1.532 3.178 3.354.57a.63.63 0 0 1 .314.152c.09.08.155.185.19.302a.702.702 0 0 1-.12.677Zm-6.135-5.164L12.676 6l-.111.045-.026.017Z M21.333 12a8.5 8.5 0 1 0-8.5 8.5V22c-5.522 0-10-4.477-10-10s4.478-10 10-10c5.523 0 10 4.477 10 10s-4.477 10-10 10v-1.5a8.5 8.5 0 0 0 8.5-8.5Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const PreferredContactFilledIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'preferredContactFilled')) as IconWithRender;

PreferredContactFilledIcon.displayName = 'PreferredContactFilledIcon';
PreferredContactFilledIcon.propTypes = Icon.propTypes;
PreferredContactFilledIcon.renderIcon = (props) => (
  <PreferredContactFilledIcon {...props} />
);
export default PreferredContactFilledIcon;
